const scopeFields=['component','repairAction','repairHours','paintRequired','locationLabel','notes','replacementMaterial','replacementThicknessIn','replacementWidthIn','replacementSheetWidthFt','replacementLengthFt','replacementQuantity'];
const code=f=>`${f.cat}${f.letter}`;
const norm=value=>String(value||'').trim().toLowerCase().replace(/\s+/g,' ');
const componentKey=value=>norm(value)==='fascia'?'fascia board':norm(value);
const photos=list=>[...new Map(list.map(p=>[p.id||p.data,p])).values()];
export function isFumigationFinding(f){return f.kind!=='repair'&&!(f.component&&f.repairAction)&&f.cat===2&&f.letter!=='B';}
export function isRepairFinding(f){return f.kind==='repair'||!!f.repairLocations||(!f.evidence&&(f.cat===3||(f.cat===2&&(f.letter==='B'||!!f.component))));}
function nextLetter(findings,cat){
 for(let n=0;n<702;n++){
  const letter=n<26?String.fromCharCode(65+n):String.fromCharCode(64+Math.floor(n/26))+String.fromCharCode(65+n%26);
  if(cat===2&&letter==='A')continue;
  if(!findings.some(f=>f.cat===cat&&f.letter===letter))return letter;
 }
 throw Error('No unused finding code is available.');
}
function groupKey(cat,l){return `${cat}|${componentKey(l.component)}|${l.repairAction||''}${l.component&&l.repairAction?'':`|pending:${l.id}`}`;}
function locationFrom(f,markerId,index=0){
 const scope=Object.fromEntries(scopeFields.map(key=>[key,f[key]??'']));
 return {...scope,id:`${f.id}@${markerId||'report'}`,markerId:markerId||null,repairHours:index?0:(f.repairHours??''),estimateNeeded:index>0,price:index?0:Number(f.primaryPrice)||0,photos:index?[]:(f.photos||[])};
}
// Old shared pins have no individual estimates. Preserve their known total on
// the original pin; additional old locations remain explicitly unestimated.
function balanced(f){
 if(!f.repairLocations?.length)return f;
 const bank=new Map((f.photos||[]).map(p=>[p.id,p]));
 f={...f,repairLocations:f.repairLocations.map(l=>({...l,photos:(l.photos||[]).map(p=>p.data?p:bank.get(p.id)||p)}))};
 const total=f.repairLocations.reduce((n,l)=>n+(Number(l.price)||0),0),quote=Number(f.primaryPrice)||0;
 if(Math.abs(total-quote)<0.005)return f;
 let assigned=0;
 return {...f,repairLocations:f.repairLocations.map((l,i)=>{
  const price=i===f.repairLocations.length-1?Math.round((quote-assigned)*100)/100:Math.round((total?quote*(Number(l.price)||0)/total:quote/f.repairLocations.length)*100)/100;
  assigned+=price;return {...l,price};
 })};
}
function withLocations(f,job){
 if(f.repairLocations)return balanced(f);
 const pins=(job.markers||[]).filter(m=>m.id===f.markerId||(m.label||'').split('+').includes(code(f)));
 const primary=pins.find(m=>m.id===f.markerId)||pins[0];
 const ordered=primary?[primary,...pins.filter(m=>m!==primary)]:[null];
 return {...f,kind:'repair',repairLocations:ordered.map((m,i)=>{
  const l=locationFrom(f,m?.id,i);return {...l,photos:photos([...l.photos,...(m?.photos||[])])};
 })};
}
export function regroupRepairs(job){
 const original=job.findings||[],fixed=original.filter(f=>!f.repairLocations),managed=original.filter(f=>f.repairLocations);
 const buckets=new Map();
 managed.forEach(f=>balanced(f).repairLocations.forEach(l=>{
  const key=groupKey(f.cat,l);if(!buckets.has(key))buckets.set(key,{cat:f.cat,source:f,locations:[]});
  buckets.get(key).locations.push(l);
 }));
 const retained=new Map();
 managed.forEach(f=>{const key=groupKey(f.cat,{...f,id:f.repairLocations[0]?.id});if(buckets.has(key)&&!retained.has(key))retained.set(key,f);});
 const reservedIds=new Set([...retained.values()].map(f=>f.id));
 const reserved=[...fixed,...retained.values()],usedIds=new Set(fixed.map(f=>f.id));
 const grouped=[];
 for(const [key,b]of buckets){
  const previous=retained.get(key),base=previous||b.source;
  let letter=previous?.letter;
  if(!letter){letter=reserved.some(f=>f.cat===b.cat&&f.letter===base.letter)?nextLetter([...reserved,...grouped],b.cat):base.letter;}
  let id=previous?.id||base.id;if((!previous&&reservedIds.has(id))||usedIds.has(id))id=`repair_${b.locations[0].id}`;usedIds.add(id);
  const first=b.locations[0],sum=b.locations.reduce((n,l)=>n+(Number(l.repairHours)||0),0);
  grouped.push({...base,id,cat:b.cat,letter,kind:'repair',...Object.fromEntries(scopeFields.map(k=>[k,first[k]??''])),markerId:first.markerId,notes:base.notes||'',
   repairLocations:b.locations.map(l=>({...l,photos:(l.photos||[]).map(p=>({id:p.id,caption:p.caption||''}))})),repairHours:Math.round(sum*100)/100,primaryPrice:Math.round(b.locations.reduce((n,l)=>n+(Number(l.price)||0),0)*100)/100,
   photos:photos(b.locations.flatMap(l=>l.photos||[])),fumeSqft:'',fumeHeightFt:0,fumeCubicFt:0});
 }
 const oldCodes=new Set(managed.map(code));
 const markers=(job.markers||[]).map(m=>{
  if(m.type==='area')return m;
  const codes=(m.label||'').split('+').filter(c=>!oldCodes.has(c));
  grouped.forEach(f=>{if(f.repairLocations.some(l=>l.markerId===m.id))codes.push(code(f));});
  return {...m,label:[...new Set(codes)].join('+')};
 });
 return {findings:[...fixed,...grouped],markers};
}
export function findingsAtMarker(job,marker){
 const codes=(marker.label||'').split('+'),result=[];
 for(const f of job.findings||[]){
  if(f.repairLocations){
   balanced(f).repairLocations.filter(l=>l.markerId===marker.id).forEach(l=>result.push({...f,...l,id:l.id,groupId:f.id,primaryPrice:l.price,repairLocations:undefined,kind:'repair'}));
  }else if(f.markerId===marker.id||codes.includes(code(f)))result.push(f);
 }
 return result.sort((a,b)=>Number(isFumigationFinding(a))-Number(isFumigationFinding(b)));
}
export function placeFindingMarker(job,marker,codebook,settings={}){
 const findings=[...(job.findings||[])];
 for(const part of (marker.label||'').split('+')){
  const cat=Number(part[0]),letter=part.slice(1),existing=findings.find(f=>code(f)===part);
  if(existing&&!isRepairFinding(existing))continue;
  const entry=codebook.find(e=>e.cat===cat&&e.name?.startsWith(existing?.sourceCode||part));
  const template={id:`${marker.id}_f_${part}`,markerId:marker.id,cat,letter,finding:entry?.finding||existing?.finding||'',primaryRec:entry?.primaryRec||existing?.primaryRec||'',secondaryRec:entry?.secondaryRec||'',hasSecondary:!!entry?.secondaryRec,primaryPrice:entry?.defaultPrice||0,priceUnit:entry?.priceUnit||'',secPrice:0,notes:'',fumeSqft:'',fumeHeightFt:0,fumeCubicFt:0,photos:[]};
  if(isRepairFinding(existing||template)){
   if(existing){const i=findings.indexOf(existing);findings[i]=withLocations(existing,job);}
   const f={...template,letter:existing?nextLetter(findings,cat):letter,kind:'repair',sourceCode:existing?.sourceCode||part,component:'',repairAction:'repair',repairHours:1,paintRequired:true,primaryPrice:Number(settings.rates?.repairHourly)||0};
   f.repairLocations=[locationFrom(f,marker.id)];findings.push(f);
  }else findings.push(template);
 }
 return regroupRepairs({...job,findings,markers:[...(job.markers||[]),marker]});
}
// Older versions allowed repair estimates on the fumigation item. Keep that
// treatment and its quote intact when separating the recorded wood repair.
function separateLegacyTreatment(job,f,settings){
 const saved=(job.findings||[]).find(item=>item.id===f.id);
 if((saved?saved.kind:f.kind)||f.repairLocations||f.evidence||f.cat!==2||f.letter==='B'||!f.component||!(/fumigat/i.test(f.primaryRec||'')||Number(f.fumeCubicFt)>0))return null;
 const treatment={...f,primaryPrice:saved?.primaryPrice??f.primaryPrice,primaryRec:saved?.primaryRec||f.primaryRec,kind:'treatment',component:'',repairAction:'',repairHours:'',paintRequired:'',replacementMaterial:'',replacementThicknessIn:'',replacementWidthIn:'',replacementSheetWidthFt:'',replacementLengthFt:'',replacementQuantity:''};
 const repair=withLocations({...f,id:`${f.id}_woodrepair`,primaryPrice:(Number(f.repairHours)||0)*(Number(settings?.rates?.repairHourly)||0)},job);
 return {treatment,repair:{...repair,letter:nextLetter(job.findings||[],2),sourceCode:'2B',kind:'repair',finding:'Wood damaged by drywood termites noted at the marked locations.',primaryRec:/fumigat/i.test(f.primaryRec||'')?`${f.repairAction==='replace'?'Replace':'Repair'} the damaged ${f.component} at the marked locations.`:f.primaryRec,secondaryRec:'',hasSecondary:false,secPrice:0,fumeSqft:'',fumeHeightFt:0,fumeCubicFt:0,originalTreatmentId:f.id}};
}
export function updateMarkerFinding(job,markerId,id,patch,settings,estimate){
 const original=(job.findings||[]).find(f=>f.id===id||f.repairLocations?.some(l=>l.id===id));
 if(!original)return {};
 if(!original.repairLocations&&!isRepairFinding(original)&&!patch.addRepair)return {findings:(job.findings||[]).map(f=>f.id===id?estimate(f,patch):f)};
 let source=original,findings=[...(job.findings||[])];
 if(patch.addRepair){
  source={...original,id:`${markerId}_repair_${crypto?.randomUUID?.()||`${Date.now()}_${Math.random()}`}`,markerId,kind:'repair',letter:nextLetter(findings,original.cat),sourceCode:`${original.cat}B`,component:'',repairAction:'repair',repairHours:1,primaryPrice:0,photos:[],secondaryRec:'',hasSecondary:false,finding:'Wood damaged by drywood termites noted at area(s) marked on diagram.',primaryRec:'Repair the damaged wood at the marked locations.',fumeSqft:'',fumeHeightFt:0,fumeCubicFt:0};
  source.primaryPrice=Number(settings.rates?.repairHourly)||0;source.repairLocations=[locationFrom(source,markerId)];findings.push(source);patch={};id=source.repairLocations[0].id;
 }else{
  const separated=separateLegacyTreatment(job,original,settings);
  if(separated){
   source=separated.repair;findings=findings.map(f=>f===original?separated.treatment:f);findings.push(source);
   id=source.repairLocations.find(l=>l.markerId===markerId)?.id||source.repairLocations[0].id;
  }else{source=withLocations(original,job);findings=findings.map(f=>f===original?source:f);}
 }
 const sharedFields=['finding','primaryRec','secondaryRec','hasSecondary'];
 const shared=Object.fromEntries(sharedFields.filter(k=>Object.hasOwn(patch,k)).map(k=>[k,patch[k]]));
 const local=Object.fromEntries(Object.entries(patch).filter(([k])=>!sharedFields.includes(k)));
 source={...source,...shared,repairLocations:source.repairLocations.map(l=>{
  if(l.id!==id&&!(original.id===id&&l.markerId===markerId))return l;
  const edited=estimate({...source,...l,primaryPrice:l.price,repairLocations:undefined,kind:'repair'},local);
  return {...l,...Object.fromEntries(scopeFields.map(k=>[k,edited[k]??''])),estimateNeeded:Object.hasOwn(local,'repairHours')?false:l.estimateNeeded,price:edited.primaryPrice};
 })};
 source.primaryPrice=source.repairLocations.reduce((n,l)=>n+(Number(l.price)||0),0);
 findings=findings.map(f=>f.id===source.id?source:f);
 return regroupRepairs({...job,findings});
}
export function changeMarkerPhotos(job,markerId,change,targetId){
 const at=findingsAtMarker(job,(job.markers||[]).find(m=>m.id===markerId)||{id:markerId});
 const target=(targetId?at.find(f=>f.id===targetId||f.groupId===targetId):null)||at.find(f=>f.kind==='repair')||at[0];
 const ids=new Set(target?[target.groupId||target.id]:[]);
 let found=false;
 const findings=(job.findings||[]).map(f=>{
  if(!ids.has(f.id))return f;found=true;
  if(f.repairLocations)return {...f,repairLocations:f.repairLocations.map(l=>l.markerId===markerId&&(!target?.groupId||l.id===target.id)?{...l,photos:change(l.photos||[])}:l)};
  return {...f,photos:change(f.photos||[])};
 });
 if(found)return regroupRepairs({...job,findings});
 return {markers:(job.markers||[]).map(m=>m.id===markerId?{...m,photos:change(m.photos||[])}:m)};
}
export function repairLocationSummary(l,index){return `${l.locationLabel||`Location ${index+1}`} · ${l.estimateNeeded?'hours not yet entered':`${Number(l.repairHours)||0} hrs`}${l.paintRequired===true?' · Painting required':l.paintRequired===false?' · No painting required':''}`;}

export function saveRepairFinding(job,f,settings={}){
 const separated=separateLegacyTreatment(job,f,settings);
 if(separated){
  const findings=(job.findings||[]).map(item=>item.id===f.id?separated.treatment:item);
  return regroupRepairs({...job,findings:[...findings,separated.repair]});
 }
 const value=!f.evidence&&isRepairFinding(f)&&f.component&&f.repairAction?withLocations(f,job):f;
 const exists=(job.findings||[]).some(item=>item.id===f.id);
 return regroupRepairs({...job,findings:exists?job.findings.map(item=>item.id===f.id?value:item):[...(job.findings||[]),value]});
}
